import { render } from "./Photo.vue?vue&type=template&id=24e0a539"
import script from "./Photo.vue?vue&type=script&lang=js"
export * from "./Photo.vue?vue&type=script&lang=js"

import exportComponent from "/home/khan/WebstormProjects/untitled/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__